import axios from 'axios'
import store from '@/store'
import Cookies from 'js-cookie'

async function getPartnerAssets(partner) {
    try {
        store.commit('user/setLoading', true)
        
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/clients/v1/partner/assets`, {
            params: {
                partner
            }
        })

        Cookies.set('partnerAssets', result.data.payload, {
            expires: 1,
            domain: process.env.VUE_APP_ROOT_DOMAIN
        })

        store.commit('user/setLoading', false)

        return result.data.payload
    } catch (e) {
        return e.response
    }

}

export default getPartnerAssets